/*
 *   File : search-funds.js
 *   Author : https://evoqins.com
 *   Description : Funds search modal component
 *   Integrations : NA
 *   Version : 1.0.0
*/

// packages
import React, { useEffect, useState } from 'react';

//Custom components
import { Icon } from '../Icon';
import { CustomSearchInput } from '../FormElements';

//style
import style from "../../Style/Component/modal.module.scss";
import { APIService } from '../../Service';

const SearchFundModal = (props) => {

    const [searchValue, setSearchValue] = useState("");

    const [fundData, setFundData] = useState([]);
    const [loader, setLoader] = useState(true);

    useEffect(() => {
        _getFunds();
    }, [searchValue]);

    // handle close modal
    const _handleCloseModal = () => {
        var button = document.getElementById("search-fund-modal-close");
        button.click();
        props.handleClose();
    };

    // handle select fund 
    const _handleSelectFund = (fund) => {
        props.handleSuccess(fund);
        _handleCloseModal();
    }

    // API - Get fund list
    const _getFunds = () => {
        let is_post = true;
        let url = 'manage-basket/get-fund';
        let request = {
            "query": searchValue,
            "recommended_fund_query": false
        }
        setLoader(true);
        APIService(is_post, url, request).then((response) => {
            if (response.status_code === 200) {
                setFundData(response.data.fund_name);
            }
            else {
                setFundData([]);
            }
            setTimeout(() => {
                setLoader(false);
            }, 300);
        });
    };

    return (
        <div className="modal fade"
            id="search-fund-modal"
            data-bs-backdrop="static"
            data-bs-keyboard="false"
            tabIndex="-1"
            aria-labelledby="SearchFundModalLabel"
            aria-hidden="true">

            <div className={`${style.e_search_modal} modal-dialog modal-dialog-centered modal-dialog-scrollable border-radius-28 `}>
                <span id='search-fund-modal-close' className='d-none' data-bs-dismiss="modal"></span>
                <div className={`${style.e_search_modal_content} modal-content border-radius-28 overflow-hidden border-0 pb-4`}>

                    {/* modal header */}
                    <div className="modal-header flex-column border-0 align-items-start padding-32px-lr padding-32px-top pb-3">
                        <div className='d-flex align-items-center justify-content-between w-100 pb-4'>
                            <h6 className='mb-0 e-text-chinese-black e-primary-font e-font-16 e-font-weight-600 line-height-24px'>
                                Search funds
                            </h6>

                            <Icon icon='close'
                                size="1.125rem"
                                className="d-flex cursor-pointer"
                                onClick={_handleCloseModal} />
                        </div>

                        <div className='w-100'>
                            <CustomSearchInput label="Fund name"
                                placeholder="Search for funds"
                                type="text"
                                required={true}
                                value={searchValue}
                                clearIcon='top-18px right-30px'
                                className="w-100"
                                inputType={2}
                                onClear={() => setSearchValue("")}
                                handleChange={(e) => setSearchValue(e)} />
                        </div>
                    </div>

                    {/* Modal body */}
                    <div className='modal-body pt-1 padding-32px-lr'>
                        {loader ?
                            <div className='d-flex h-100 align-items-center justify-content-center'>
                                <img src={require("../../Assets/Image/loader.gif")}
                                    draggable={false}
                                    width={80}
                                    height={80}
                                    alt='loader'
                                    className='text-center' />
                            </div>
                            :
                            fundData.length !== 0 ?
                                <div className='e-border-bottom-1px-pale-lavender-light '>
                                    {fundData.map((fund, key) => (
                                        <div key={key} className={`${style.e_funds_wrapper} py-3 px-4 cursor-pointer`}
                                            onClick={() => _handleSelectFund(fund)}>
                                            <div className='row'>
                                                <div className='col-10'>
                                                    <div className='d-flex align-items-center gap-2'>
                                                        <div className={`${style.e_fund_img_wrapper} e-bg-white padding-2px-all border-radius-4`}>
                                                            <img src={fund.image}
                                                                draggable={false}
                                                                width={20}
                                                                className='d-flex'
                                                                height={20}
                                                                alt='fund' />
                                                        </div>
                                                        <p className='mb-0 e-text-smoky-black e-alt-font e-font-14 e-font-weight-400 line-height-24px'>
                                                            {fund.label}
                                                        </p>
                                                    </div>
                                                </div>
                                                <div className='col-2'>
                                                    <p className='mb-0 e-text-smoky-black e-alt-font e-font-14 e-font-weight-400 line-height-24px'>
                                                        {fund.allocation}
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                                :
                                <div className='d-flex align-items-center flex-column justify-content-center h-100'>
                                    <img src={require("../../Assets/Image/NotFound/no-data.png")}
                                        width={160}
                                        height={160}
                                        alt='no data' />

                                    <h6 className='mb-1 mt-2 e-text-dark-gray e-alt-font e-font-20 e-font-weight-600 line-height-28px '>
                                        No data found
                                    </h6>
                                    {/* <div className='row'>
                                        <div className='offset-xl-4 offset-lg-3 offset-md-2 offset-1 col-xl-4 col-lg-6 col-md-8 col-10 px-0 '>
                                            <p className={`${props.fontSize ? props.fontSize : "e-font-18 line-height-24px"} mb-0 e-text-arsenic e-alt-font  e-font-weight-400  `}>
                                                {props.description}
                                            </p>
                                        </div>
                                    </div> */}
                                </div>

                        }
                    </div>
                </div>
            </div>
        </div>
    )
}

export default SearchFundModal;
